import api from '@/api'

const { $pricing } = api;

export const { $suscriptions, $types, $products } = $pricing;
